import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Transaction from "../components/Transaction";

function ClientDetail() {
  const API_URL = process.env.REACT_APP_API_URL;

  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [client, setClient] = useState();

  const [showFundModal, setShowFundModal] = useState(false);
  const [enteredAmount, setEnteredAmount] = useState("");

  const [chooseAdd, setChooseAdd] = useState(false);

  const openAddFundModal = () => {
    setChooseAdd(true);
    setEnteredAmount("");
    setShowFundModal(true);
  };
  const openEditFundModal = () => {
    setChooseAdd(false);
    setEnteredAmount("");
    setShowFundModal(true);
  };

  const closeFundModal = () => {
    setShowFundModal(false);
    setEnteredAmount("");
  };

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_URL}/clients/${id}`)
      .then((response) => {
        setClient(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
        alert(error);
      });
  }, [id, error, API_URL]);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleBackBtn = () => {
    navigate("/dashboard");
  };

  const handleAddFunds = async () => {
    if (!enteredAmount || isNaN(enteredAmount)) {
      alert("Please enter a valid number.");
      return;
    }

    try {
      if (chooseAdd) {
        const result = await axios.put(`${API_URL}/clients/${id}/add-fund`, {
          balance: parseFloat(enteredAmount),
        });
        alert(result.data.message);
        closeFundModal();
      } else {
        const result = await axios.put(`${API_URL}/clients/${id}/edit-fund`, {
          balance: parseFloat(enteredAmount),
        });
        alert(result.data.message);
        closeFundModal();
      }

      //refresh
      window.location.reload();
    } catch (err) {
      if (chooseAdd) {
        setError("Failed to add funds:", err);
      } else {
        setError("Failed to edit funds:", err);
      }
      alert(error);
    }
  };

  const handleEditBtn = () => {
    navigate(`/clients/${id}/edit`);
  };

  const handleDeleteBtn = async () => {
    const answer = window.confirm(
      `Are you sure you want to delete ${client.name}'s information?`
    );
    if (answer) {
      try {
        await axios.delete(`${API_URL}/clients/${id}`);
        alert("Client deleted successfully.");
      } catch {
        setError(
          "Something went wrong while deleting the clinet. Please try it again later"
        );
        alert(error);
      }
      navigate("/dashboard");
    } else {
      return;
    }
  };

  const handlePlusBtn = () => {
    navigate(`/clients/${id}/addTransaction`);
  };
  return (
    <div className="h-dvh flex items-center flex-col bg-[#545454]">
      <title>Client Detail | HairBank</title>
      <div className="flex w-full pl-10">
        <div className="flex justify-start items-end">
          <button
            onClick={handleBackBtn}
            className="text-white text-3xl hover:text-[#eed495]"
          >
            Back
          </button>
        </div>
        <div className="w-full flex">
          <h1 className="text-[#eed495] text-6xl mt-16 xl:mt-5 w-full text-center mr-28">
            Client Detail
          </h1>
        </div>
      </div>

      <div className="w-auto mt-10 ">
        <div className="flex justify-end">
          <button
            className="text-3xl text-white border-2 mt-2 w-48 text-center  hover:text-[#eed495]"
            onClick={openAddFundModal}
          >
            Add Fund
          </button>
          <button
            className="text-3xl text-white border-2 mt-2 w-48 text-center  hover:text-[#eed495]"
            onClick={openEditFundModal}
          >
            Edit Fund
          </button>
          <button
            className="text-3xl text-white border-2 mt-2 w-48 text-center  hover:text-[#eed495]"
            onClick={handleEditBtn}
          >
            Edit Info
          </button>
          <button
            className="text-3xl text-white border-2 mt-2 w-48 text-center  hover:text-[#eed495]"
            onClick={handleDeleteBtn}
          >
            Delete
          </button>
        </div>
        <div className="w-auto grid  grid-cols-6 px-2  border-2 text-lg text-white mt-6">
          <label>Name:</label>
          <div className="text-[#eed495]">{client && client.name}</div>
          <label>Gender:</label>
          <div className="text-[#eed495]">{client && client.gender}</div>
          <label>Contact:</label>
          <div className="text-[#eed495]">{client && client.contact}</div>
          <label>Membership:</label>
          <div className="text-[#eed495]">{client && client.membership}</div>
          <label>Balance:</label>
          <div className="text-[#eed495]">{client && client.balance}</div>
          <label>Prepaid:</label>
          <div className="text-[#eed495]">{client && client.prepaid}</div>
          <label>Start Date:</label>
          <div className="text-[#eed495] ">
            {client && client.startdate.split("T")[0]}
          </div>
          <label>Email:</label>
          <div className="text-[#eed495]">{client && client.email}</div>
        </div>
        {showFundModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-96 h-64 shadow-lg text-center">
              <h2 className="text-2xl font-semibold mb-4">Enter Funds</h2>
              <input
                type="number"
                placeholder="Enter amount"
                value={enteredAmount}
                onChange={(e) => setEnteredAmount(e.target.value)}
                className="border p-2 w-full mb-4 text-lg mt-6"
              />
              <div className="flex justify-center gap-4 mt-6">
                <button
                  onClick={handleAddFunds}
                  className="bg-[#eed495] text-white px-4 py-2 rounded"
                >
                  Confirm
                </button>
                <button
                  onClick={closeFundModal}
                  className="bg-gray-300 px-4 py-2 rounded"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="text-center mt-12 text-[#eed495] text-4xl">
        <h1>Transaction History</h1>
      </div>
      <div className="w-11/12 flex justify-end">
        <button
          className="text-3xl text-[#eed495] border-2 w-14 text-center  hover:text-white"
          onClick={handlePlusBtn}
        >
          +
        </button>
      </div>
      <Transaction />
    </div>
  );
}

export default ClientDetail;
